import Utterances from './Utterances';

export default Utterances;
